import React, { useEffect, useState } from "react"
import { Dropdown } from "react-bootstrap"

type Params = {
    values: { [a: string]: string },
    selectedIndex?: number,
    onSelected?: (key: string) => void
}

export function SimpleDropdown({ values, selectedIndex, onSelected }: Params) {

    const [selected, setSelected] = useState<string | null>()

    useEffect(() => {
        if (selectedIndex !== undefined) {
            setSelected(Object.keys(values)[selectedIndex])
        }
    }, [])

    const onSelect = (key: string | null) => {
        setSelected(key)
        onSelected?.(key!)
    }

    return <>
        <Dropdown onSelect={onSelect} className="dropdown my-1 cursor-pointer">
            <Dropdown.Toggle
                className="dropdown-toggle inline-flex w-32 items-center justify-between rounded-lg border border-jacarta-100 bg-white py-2 px-3 text-sm dark:border-gray-400 dark:bg-gray-900 dark:text-white"
                role="button" id="sort" data-bs-toggle="dropdown" aria-expanded="false">
                <span className="font-display">{selected ? values[selected] : "Select"}</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                    className="h-4 w-4 fill-jacarta-500 dark:fill-white">
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" />
                </svg>
            </Dropdown.Toggle>

            <Dropdown.Menu
                className="dropdown-menu scrollable-menu z-10 hidden min-w-[220px] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl dark:bg-gray-900"
                aria-labelledby="sort">
                {Object.entries(values).map(([key, value], index) => (
                    <Dropdown.Item
                        eventKey={key}
                        key={index}
                        className="dropdown-item flex w-full items-center justify-between rounded-xl px-5 py-2 text-left font-display text-sm text-jacarta-700 transition-colors hover:bg-jacarta-50 dark:text-white dark:hover:bg-jacarta-600">
                        {value}
                        {selected === key ? <Check /> : <></>}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    </>
}

function Check() {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
        className="mb-[3px] h-4 w-4 fill-accent">
        <path fill="none" d="M0 0h24v24H0z" />
        <path d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z" />
    </svg>
}